import {Component, TemplateRef, ViewChild} from '@angular/core';

@Component({
  templateUrl: './global-templates.component.html',
})
export class GlobalTemplatesComponent {
  // @ViewChild('nzIndicatorTpl', { static: true })
  // nzIndicator!: TemplateRef<void>;

  @ViewChild('nzEmptyTpl', { static: true })
  nzEmpty!: TemplateRef<any>;
}
